import { render, staticRenderFns } from "./ShopifyCarousel.vue?vue&type=template&id=e832ce02&"
import script from "./ShopifyCarousel.vue?vue&type=script&lang=js&"
export * from "./ShopifyCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports